import type { ComponentPropsWithRef, ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';
import { Icon } from '@/shared/ui/icon';

import styles from './checkbox.module.scss';

export type CheckboxProps = Omit<ComponentPropsWithRef<'input'>, 'type'> & {
  label: ReactNode;
  /** "default" — wine square; "filter" — catalog filter; "inverse" — dark footer. */
  tone?: 'default' | 'filter' | 'inverse';
  invalid?: boolean;
};

export function Checkbox({
  label,
  className,
  tone = 'default',
  invalid = false,
  ...props
}: CheckboxProps) {
  return (
    <label
      className={cx(styles.root, className)}
      data-tone={tone}
      data-invalid={invalid || undefined}
    >
      <input
        {...props}
        type="checkbox"
        className={styles.input}
        aria-invalid={invalid || undefined}
      />
      <span className={styles.box} aria-hidden="true">
        <Icon name="check" size={12} strokeWidth={2.6} />
      </span>
      <span className={styles.text}>{label}</span>
    </label>
  );
}
